const { docToEntity } = require('./../../tools')

// If `unfiltered` is true, fetch the full programs doc (returns every tenant's
// programs - admin/server callers only). Otherwise scope the read to the
// user's programs via the by-id view so cross-tenant data never crosses the
// wire. Issue #22039.
exports.listPrograms = async function (state, { unfiltered } = {}) {
  if (unfiltered) {
    const doc = await state.dal.program.getPrograms(state)
    return docToEntity(doc, false)
  }

  const userPrograms = (state.user && state.user.programs) || []
  const doc = await state.dal.program.getProgramsByIds(state, userPrograms)
  return docToEntity(doc, false)
}
